export const cities = (state) => {
  return state.cities
}
